import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/_molecules/Modal'
import CrossIcon from 'components/icons/Cross'

import './styles.css'

class MagicDrawer extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    drawerOpen: PropTypes.bool.isRequired,
    actions: PropTypes.shape({
      closeMagicDrawer: PropTypes.func.isRequired,
    }).isRequired,
  }

  close = () => {
    this.props.actions.closeMagicDrawer()
  }

  render() {
    const {
      children,
      drawerOpen,
    } = this.props

    const iconProps = {
      fill: '#FFF',
      width: 32,
    }

    // use modal so that we leverage react portal
    // and utilise the same z-index space as the other modals
    return (
      <Modal
        modalTitle=""
        isOpen
        modalHeader={false}
        onRequestClose={this.close}
        shouldCloseOnOverlayClick={false}
        className="magic-drawer-modal"
        overlayClassName="magic-drawer-modal-overlay"
      >

        <div data-component="MagicDrawer" className={`MagicDrawer ${drawerOpen ? ' drawer-open' : ''}`}>

          <button className="magic-drawer-close" onClick={this.close}>
            <CrossIcon {...iconProps} />
          </button>

          <div className="drawer-inner">{children}</div>

        </div>

      </Modal>
    )
  }
}

export default MagicDrawer



// WEBPACK FOOTER //
// ./src/components/MagicDrawer/component.js